// Advanced Permissions for vendor contacts (per project, per contact).
// The panel renders one column per entry in VENDOR_PERMISSION_DEFS, so adding a
// future permission only requires appending an entry here (and gating the relevant view).

export interface VendorPermissionDef {
  key: string;
  label: string;
}

// NK-309: Survey Quotas is no longer a permission — vendors see the quota screen on any
// P&H + Decipher project, gated in project-details instead of per contact.
export const VENDOR_PERMISSION_DEFS: VendorPermissionDef[] = [
  { key: 'ProjectFolder', label: 'Survey Data' }
];

export interface VendorContactPermissionItem {
  contactId: string;
  permissionKeys: string[];
}

// The "apply to all (and future) contacts" grant for one vendor on a project.
export interface VendorAllContactsGrant {
  partnerId: string;
  permissionKeys: string[];
}

// A Decipher layout a vendor is allowed to download for a project's data file (NK-263).
export interface VendorLayout {
  layoutId: string;
  layoutDescription: string;
}

// The Decipher layouts allowed for one vendor on a project (NK-263).
export interface VendorAllowedLayouts {
  partnerId: string;
  layouts: VendorLayout[];
}

// Read shape: explicit per-contact grants, per vendor "all contacts" state, and (NK-263)
// per vendor the Decipher layouts that vendor is allowed to download.
export interface VendorPermissionsResult {
  items: VendorContactPermissionItem[];
  allContacts: VendorAllContactsGrant[];
  allowedLayouts: VendorAllowedLayouts[];
}

// Save payload. items fully replace the project's per-contact grants; partnerId +
// allContactsPermissionKeys carry the current vendor's "all contacts" state; allowedLayouts
// (NK-263) carries that same vendor's allowed Decipher layouts.
export interface VendorPermissionSave {
  items: VendorContactPermissionItem[];
  partnerId?: string;
  allContactsPermissionKeys?: string[];
  allowedLayouts?: VendorLayout[];
}
